import {
    Button, Dialog, DialogTitle, Grid, Paper, styled, Table, TableBody, TableCell,
    tableCellClasses, TableContainer, TableHead, TableRow, ToggleButton
} from '@mui/material';
import FileSaver from 'file-saver';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import BillingService from '../../Services/billing/BillingService';
import ChecklistService from '../../Services/ChecklistService';
import Home from '../home/Home'
import Snacbar from '../Snacbar'
import { getDate, getPointId, getUserId } from '../Utils/Common';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    // backgroundColor: '#edf4f2',

}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    // backgroundColor: '#edf4f2',

}));

const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder',
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        fontFamily: 'Times New Roman',
        textAlign: 'center'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
        color: 'black',

    },
}))
export default function CheckListAprovel() {
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');

    const [OpenViewJob, setOpenViewJob] = useState(false);

    const [nonUplodedetails, setnonUplodedetails] = useState([]);
    const [Uplodedetails, setUplodedetails] = useState([]);
    const [ImporterDetails, setImporterDetails] = useState([]);
    const [JobTrackingDetails, setJobTrackingDetails] = useState([]);
    const [ChecklistAPPVERISUBMISSION, setChecklistAPPVERISUBMISSION] = useState([]);

    const [consigmnt, setConsigment] = useState('');

    const [values, setValues] = useState({
        txt_customer: '',
        txt_aprovalSts: '',
        txt_aprovalDate: getDate(),
        txt_aprovalRemarks: '',
        txt_jobNo: '',
        checklistcopyNo: ''
    })
    const [Checklistcopy, setChecklistcopy] = useState('');
    const [jobentryDetails, setjobentryDetails] = useState({
        txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
        ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
        txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
        lbl_asHawbNo: 'HAWB.No',
    })

    //OnChangeEvente
    const CustomerChangeHandle = (e) => {
        setValues({ ...values, txt_customer: e.target.value });
        getJobNoConsoleNonUpload(e.target.value, values.txt_jobNo);
    }

    const JobNoChangeHandle = (e) => {
        setValues({ ...values, txt_jobNo: e.target.value });
        var consigmnt, importer_iec_no = '';
        if (e.target.value === '') { consigmnt = '-1' }
        else { consigmnt = e.target.value }
        if (values.txt_customer === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = values.txt_customer; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '2' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });

    }

    const ApprovalStsChangeHandle = (e) => {
        setValues({ ...values, txt_aprovalSts: e.target.value });
    }

    const ApprovalDateChangeHandle = (e) => {
        setValues({ ...values, txt_aprovalDate: e.target.value });
    }

    const ApprovalRemarksChangeHandle = (e) => {
        setValues({ ...values, txt_aprovalRemarks: e.target.value });
    }
    //dialog
    const CloseViewJobHandle = () => {
        setOpenViewJob(false);
    }
    const OpenViewJobHandle = () => {
        if (selected === '') {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job.No From Job Table');
        } else {
            setOpenViewJob(true);
        }
    }
    //getDatas
    const getDrpData = async () => {
        BillingService.getImporterDetails().then((res) => {
            setImporterDetails(res.data);
        })
    }

    const getJobNoConsoleNonUpload = (val, val2) => {
        var consigmnt, importer_iec_no = '';
        if (val2 === '') { consigmnt = '-1' }
        else { consigmnt = val2 }
        if (val === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = val; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '2' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });
    }

    const getData = async () => {
        BillingService.getnonAudit(2).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getAudit(2).then((res) => { setUplodedetails(res.data); });
    }


    useEffect(() => {
        getData();
        getDrpData();
    }, []);
    const [selected, setSelected] = useState([]);
    //tableClick
    const editNonSumitedDetails = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);

        setConsigment(item.consignmentNumber);
        BillingService.getJobDetailsAssign(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB No';
                AirlinesName = 'Airlines Name';
                HawbNo = 'HAWB No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL No';
                AirlinesName = 'Shipment Company';
                HawbNo = 'HBL No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].importerAddress, txt_asTransitType: lastResult[0].transitTypeName,
                txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName, txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName,
                txt_asArrivalDate: lastResult[0].expectedArrivalDateTime, txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            });
        });
        ChecklistService.getChecklist(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            if (!lastResult[0]) {
                setChecklistcopy('');
                setValues({ ...values, checklistcopyNo: '', txt_aprovalDate: getDate(), txt_aprovalRemarks: '', txt_aprovalSts: '' });
            } else {
                setChecklistcopy(lastResult[0].checklistCopy);
                setValues({ ...values, checklistcopyNo: lastResult[0].checklistNo, txt_aprovalDate: getDate(), txt_aprovalRemarks: '', txt_aprovalSts: '' });
            }

        }); setChecklistAPPVERISUBMISSION([]);
        ChecklistService.getJobTrackingDetails(item.consignmentNumber).then((res) => {
            setJobTrackingDetails(res.data);
        })
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;

    const editSumitedDetails = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);

        setConsigment(item.consignmentNumber);
        BillingService.opgetConsignmentJobEntryAssign(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].senderAddress, txt_asTransitType: lastResult[0].transitTypeName,
                txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName, txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName,
                txt_asArrivalDate: lastResult[0].expectedArrivalDateTime, txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            });
        });
        ChecklistService.getChecklist(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            if (!lastResult[0]) {
                setChecklistcopy('');
            } else {
                setChecklistcopy(lastResult[0].checklistCopy);
            }

        });
        ChecklistService.getChecklistAPPVERISUBMISSION(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            if (!lastResult[0]) {
                setValues({
                    ...values, txt_aprovalSts: '', checklistcopyNo: '',
                    txt_aprovalDate: '', txt_aprovalRemarks: '',
                })
            } else {
                setValues({
                    ...values, checklistcopyNo: lastResult[0].checklistNo, txt_aprovalSts: lastResult[0].approvalStatus,
                    txt_aprovalDate: lastResult[0].approvalDate, txt_aprovalRemarks: lastResult[0].approvalRemarks
                })
            }
            setChecklistAPPVERISUBMISSION(res.data);
        })
        ChecklistService.getJobTrackingDetails(item.consignmentNumber).then((res) => { setJobTrackingDetails(res.data); })
    }

    const isAprvlSelected = (name) => selected.indexOf(name) !== -1;

    //ClickEvents

    const [saveDsa, setSaveDsa] = useState(false);
    const [processing, setprocessing] = useState(false)

    const DownlodCheacklist = () => {
        if (consigmnt !== '') {
            if (Checklistcopy === '' || !Checklistcopy) {
                setOpen(true); setSeverity('warning'); setMessage('CheckList Copy is Empty');
            } else {
                var file = b64toBlob(Checklistcopy, 'application/pdf')
                // var blob = new Blob(Checklistcopy, {type: "base64;charset=utf-8"});
                // setOpen(true);setSeverity('warning'); setMessage(Checklistcopy);
                // FileSaver.saveAs(Checklistcopy,values.checklistcopyNo+".pdf");
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file);
                }
                else {
                    var fileURL = URL.createObjectURL(file);
                    FileSaver.saveAs(fileURL, values.checklistcopyNo + ".pdf");
                }
            }
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job.No From Job Tabel');
        }
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    const update = () => {
        if (consigmnt !== '') {
            if (values.txt_aprovalSts !== '') {
                setSaveDsa(true); setprocessing(true);
                let details = {
                    consignmentId: consigmnt, approvalStatus: values.txt_aprovalSts, approvalDate: values.txt_aprovalDate,
                    approvalRemarks: values.txt_aprovalRemarks, createdBy: getUserId(), pointId: getPointId()
                }
                ChecklistService.updateChecklistApproval(details).then((res) => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setOpen(true); setSeverity('success'); setMessage(message);
                    } else {
                        setOpen(true); setSeverity('error'); setMessage('Update Failed ' + message);
                    } refresh();
                }).catch((error) => {
                    setOpen(true); setSeverity('success'); setMessage('Update Failed ' + error.message); refresh();
                })
            } else {
                document.getElementById('approvalSts').focus();
                setOpen(true); setSeverity('warning'); setMessage('Please Select approvalStatus..!');
            }
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job.No From Job Table');
        }
    }


    const search = () => {
        getJobNoConsoleNonUpload(values.txt_customer, values.txt_jobNo)
    }

    const refresh = () => {
        setSaveDsa(false); setprocessing(false);
        setConsigment('');
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '', txt_asClearancePort: '',
            txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: '', lbl_asAirlinesName: '', lbl_asHawbNo: ''
        });
        setChecklistcopy('');
        setChecklistAPPVERISUBMISSION([]); setJobTrackingDetails([]);
        setValues({ ...values, checklistcopyNo: '', txt_aprovalDate: getDate(), txt_aprovalRemarks: '', txt_aprovalSts: '', txt_customer: '', txt_jobNo: '' });
        getData();
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/Voucher');
    }
    const ForwordBotton = () => {
        navigate('/checklistSndParty');
    }
    //handleClose/open
    const handleClose = () => { setOpen(false); setSeverity(''); setMessage(''); }
    return (
        <div>
            <Home /> <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
            {/* view Job */}
            <Dialog open={OpenViewJob} onClose={CloseViewJobHandle} fullWidth={true} maxWidth='lg'>
                <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center>Job Entry Details</center></DialogTitle>
                <Paper sx={{ height: 250 }}>
                    <Row className='mt-1 p-2'>
                        <Col className='jobentrAssign' xs={4}>
                            <Row xs={5}>
                                <Col xs={5}><label style={jobentrylablestyle}>Job.No</label></Col>
                                <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asJobNo} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>MAWB.No</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asMawbNo} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Name</label></Col>
                                <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asImporterName} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Code</label></Col>
                                <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asImporterCode} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer State</label></Col>
                                <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asImporterState} /></Col>
                            </Row>
                        </Col>

                        <Col className='jobentrAssign'>
                            <Row xs={5}>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Address</label></Col>
                                <Col className='jobentrAssign'><textarea rows="4" cols="17" disabled className='textAreaummurry scrollbarPrime'>{':' + jobentryDetails.ta_asimporterAddress}</textarea></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Transit Type</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asTransitType} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>AirLines Name</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asAirlinesName} /></Col>
                            </Row>
                        </Col>
                        <Col className='jobentrAssign'>
                            <Row xs={5}>
                                <Col xs={4}><label style={jobentrylablestyle}>Origin Country</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asOriginCountry} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Origin Port</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asOriginPort} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Clearance Port</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asClearancePort} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Arrival Date</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asArrivalDate} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>HAWB.No</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={': ' + jobentryDetails.txt_asHawbNo} /></Col>
                            </Row>
                        </Col>
                    </Row>
                </Paper>
            </Dialog>
            {/* //design... */}
            <div style={{ paddingLeft: '100px' }}>
            <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid container>
                    <Grid item xs={2}>
                        <ItemPap style={{ height: 428 }}>
                            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" > <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                            <lable style={{ fontSize: '13px', fontFamily: 'Times New Roman', fontWeight: 'bold', color: 'red', marginLeft: '15px' }}>NonApproval Job</lable>

                            <TableContainer sx={{ maxHeight: 380 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {nonUplodedetails.map((item) => {
                                            const isItemSelected = isSelected(item.consignmentId);
                                            return (
                                                <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editNonSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                    <Grid item xs={8}>
                        <Grid container >
                            <ItemPap style={{ height: 428 }} >
                                <div className=''>
                                    <div className='form-inline  mt-2 mb-2 p-1'>
                                        <Row>
                                            <center className='mb-3 mt-2'><lable style={{ fontFamily: 'Times New Roman', fontSize: '25px', fontWeight: 'bold', color: 'red' }}>CHECK LIST APPROVAL</lable></center>
                                            <Col></Col>
                                            <Col style={{textAlign:'right'}}>
                                                <Form.Label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>Customer</Form.Label>
                                            </Col>
                                            <Col xs={3}>
                                                <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', height: '26px', fontWeight: 'bold', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center' }} value={values.txt_customer} onChange={CustomerChangeHandle}>
                                                    <option value=''></option>
                                                    {ImporterDetails.map((item) => (
                                                        <option key={item.serialNumber} value={item.importer_iec_no}>{item.importer_name}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col style={{textAlign:'right'}}>
                                                <Form.Label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>JobNo</Form.Label>
                                            </Col>
                                            <Col xs={2}>
                                                <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', fontWeight: 'bold', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center' }} value={values.txt_jobNo} onChange={JobNoChangeHandle} />
                                            </Col>
                                            <Col>
                                                <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} size='small' onClick={search}>search</Button>
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                    </div>
                                    <Row className='mt-5'>
                                        <Col></Col>
                                        <Col style={{textAlign:'right'}}>
                                            <Form.Label className='billingIpTitle' >ApprovalStatus</Form.Label>
                                        </Col>
                                        <Col>
                                            <Form.Select size='sm' style={{width:'170px', fontFamily: 'Times New Roman', border: '1px solid black', fontWeight: 'bold', color: 'black' }} className='cntrtxt' value={values.txt_aprovalSts} onChange={ApprovalStsChangeHandle}
                                                id='approvalSts'>
                                                <option value={''}></option>
                                                <option value={'YES'}>YES</option>
                                                <option value={'NO'}>NO</option>
                                            </Form.Select>
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                    <Row className='mt-3'>
                                        <Col></Col>
                                        <Col style={{textAlign:'right'}}>
                                            <Form.Label className='billingIpTitle'>ApprovalDate</Form.Label>
                                        </Col>
                                        <Col>
                                            <Form.Control type='date' style={{width:'170px', fontFamily: 'Times New Roman', border: '1px solid black', fontWeight: 'bold' }} className='cntrtxt' value={values.txt_aprovalDate} onChange={ApprovalDateChangeHandle} />
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                    <Row className='mt-3'>
                                        <Col></Col>
                                        <Col style={{textAlign:'right'}}>
                                            <Form.Label className='billingIpTitle'>ApprovalRemarks</Form.Label>
                                        </Col>
                                        <Col >
                                            <Form.Control size='sm' as='textarea' style={{ width:'170px',fontFamily: 'Times New Roman', fontWeight: 'bold', border: '1px solid black' }} rows='3' className='cntrtxt' value={values.txt_aprovalRemarks} onChange={ApprovalRemarksChangeHandle} />
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                    <center><div className='mt-4'>
                                        <Button color="success" variant="contained" style={{ fontFamily: 'Times New Roman', }} size='small' onClick={DownlodCheacklist}>DOWNLOAD CHECKLIST COPY</Button>{' '}
                                        <Button variant='contained' color="primary" style={{ fontFamily: 'Times New Roman', }} size='small' disabled={saveDsa} onClick={update}>{processing ? 'processing' : 'UPDATE'}</Button>{' '}
                                        <Button variant='contained' color="warning" style={{ fontFamily: 'Times New Roman', }} size='small' onClick={refresh}>REFRESH</Button>{' '}
                                        <Button variant='contained' color="info" style={{ fontFamily: 'Times New Roman', }} size='small' onClick={OpenViewJobHandle}>VIEW JOB ENTRY DETAILS</Button>{' '}
                                    </div></center>
                                </div>
                            </ItemPap>
                        </Grid>
                    </Grid>
                    <Grid item xs={2}>
                        <ItemPap1 style={{ height: 428 }}>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red', marginRight: '30px' }}>Approval Job</lable>
                            {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 380 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Uplodedetails.map((item) => {
                                            const isItemSelected = isAprvlSelected(item.consignmentId);
                                            return (
                                                <TableRow hover key={item.consignmentId} selected={isItemSelected} tabIndex={-1} onClick={() => editSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </TableRow>)
                                        })}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap1>
                    </Grid>
                    <Grid item xs={6} >
                        <ItemPap>
                            <TableContainer sx={{ height: 199 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                            <StyledTableCell align='center' style={{ textAlign: 'center' }}>Checlist No</StyledTableCell>
                                            <StyledTableCell align='center'>ClApproval Sts</StyledTableCell>
                                            <StyledTableCell align='center'>ClApproval Date</StyledTableCell>
                                            <StyledTableCell align='center'>ClApproval Remarks</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ChecklistAPPVERISUBMISSION.map((item) => (
                                            <TableRow hover key={item.consignmentId} >
                                                <StyledTableCell align='center'>{item.consignmentId}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.checklistNo}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalStatus}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalDate}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalRemarks}</StyledTableCell>
                                            </TableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                    <Grid item xs={6}>
                        <ItemPap>
                            <center><lable style={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 'bold', color: 'red' }}>Job Tracking Details</lable></center>

                            <TableContainer sx={{ height: 174 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Operation Location</StyledTableCell>
                                            <StyledTableCell align='center'>Operation Date</StyledTableCell>
                                            <StyledTableCell align='center'>Operation Status</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {JobTrackingDetails.map((item) => (
                                            <TableRow hover key={item.serialNumber} >
                                                <StyledTableCell align='center'>{item.userLocation}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.operationDate}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.operationStatus}</StyledTableCell>
                                            </TableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}
